const styles = theme => ({
  root: {
    padding: theme.spacing(2),
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
  },
  stepper: {
    padding: theme.spacing(3, 1),
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    overflow: 'hidden',
  },
})

export default styles
